import JobSummaryPage from './JobSummaryPage';

export default JobSummaryPage;
